import { getMenus } from '../lib/menus';
import { getNews } from '../lib/pages';
import NewsLayout from '../layouts/news/index';

export default function Awards(props) {
    return <NewsLayout pageProps={props} />;
}

export async function getStaticProps(context) {
    const menus = {};

    const news = await getNews();
    (getMenus(news)).map((menu) => (menus[menu.slug] = menu));
    let options = news.options.acf_site_options;

    let nextSeoProps = {
        canonical: 'https://' + process.env.NEXT_PUBLIC_SITE_DOMAIN + '/news/',
        title: 'In The News - Enfusion',
        openGraph: {}
    };

    const seo = news.homeSeoContent.seo;
    if (seo.opengraphImage) {
        nextSeoProps.openGraph.images = [
            {
                url: seo.opengraphImage.sourceUrl,
                alt: seo.opengraphImage.altText,
                width: seo.opengraphImage.mediaDetails.width,
                height: seo.opengraphImage.mediaDetails.height
            }
        ];
    } else {
        /* Fallback to the Twitter card */
        nextSeoProps.openGraph.images = [
            {
                url:
                    'https://enfusion-api.webworkinprogress.com/wp-content/uploads/2021/05/home-preview.png',
                alt: 'Enfusion',
                width: 1900,
                height: 1053
            }
        ];
    }
    return {
        props: {
            menus,
            options,
            news,
            nextSeoProps
        }
    };
}
